<template>
  <div>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      :permission="permissionList"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    >
      <template slot="currentStock" slot-scope="{ row }">
        <span :class="{ 'stock-warning': isStockInsufficient(row) }">
          {{ row.currentStock || 0 }}
          <span v-if="isStockInsufficient(row)" class="warning-text">(不足)</span>
        </span>
      </template>
      <template slot="status" slot-scope="{ row }">
        <el-tag :type="getStatusType(row.status)" size="small">
          {{ getStatusLabel(row.status) }}
        </el-tag>
      </template>
      <template slot="menu" slot-scope="{ row }">
        <template v-if="row.status === 0">
          <el-button type="text" size="small" style="color: #67c23a" @click="handleApprove(row)">同意</el-button>
          <el-button type="text" size="small" style="color: #f56c6c" @click="handleReject(row)">拒绝</el-button>
        </template>
        <template v-else>
          <el-button type="text" size="small" @click="viewDetail(row)">详情</el-button>
        </template>
      </template>
    </avue-crud>

    <el-dialog title="拒绝原因" :visible.sync="rejectVisible" width="400px" :close-on-click-modal="false">
      <el-input
        v-model="rejectRemark"
        type="textarea"
        :rows="3"
        placeholder="请输入拒绝原因"
        maxlength="200"
        show-word-limit
      />
      <span slot="footer">
        <el-button @click="rejectVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmReject">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import crudMixins from '@/mixins/crud-mixins'
import { getList, approve, reject } from './api'
import { getUserInfo } from '@/api/system/user'

export default {
  name: 'part-request-approval',
  mixins: [crudMixins],
  data() {
    return {
      apiConfig: { getList },
      rejectVisible: false,
      rejectRemark: '',
      currentRow: null,
      option: {
        ...this.$store.state.publicOption,
        menu: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        viewBtn: false,
        menuWidth: 150,
        column: [
          {
            label: '申请单号',
            prop: 'requestNo',
            minWidth: 140,
          },
          {
            label: '备件名称',
            prop: 'partName',
            minWidth: 150,
          },
          {
            label: '申请数量',
            prop: 'requestCount',
            minWidth: 100,
            align: 'center',
          },
          {
            label: '当前库存',
            prop: 'currentStock',
            minWidth: 100,
            align: 'center',
            slot: true,
          },
          {
            label: '申请人',
            prop: 'applicantName',
            minWidth: 100,
          },
          {
            label: '申请时间',
            prop: 'requestTime',
            minWidth: 160,
            formatter: (row, value) => {
              if (!value) return '-'
              if (typeof value === 'number') {
                const date = new Date(value)
                const y = date.getFullYear()
                const m = String(date.getMonth() + 1).padStart(2, '0')
                const d = String(date.getDate()).padStart(2, '0')
                const h = String(date.getHours()).padStart(2, '0')
                const min = String(date.getMinutes()).padStart(2, '0')
                const s = String(date.getSeconds()).padStart(2, '0')
                return `${y}-${m}-${d} ${h}:${min}:${s}`
              }
              return value
            },
          },
          {
            label: '用途',
            prop: 'purpose',
            minWidth: 200,
            overHidden: true,
          },
          {
            label: '状态',
            prop: 'status',
            minWidth: 100,
            slot: true,
            search: true,
            type: 'select',
            dataType: 'number',
            dicData: [
              { label: '待审批', value: 0 },
              { label: '已批准', value: 1 },
              { label: '已拒绝', value: 2 },
            ],
          },
        ],
      },
    }
  },
  methods: {
    isStockInsufficient(row) {
      return row.currentStock < row.requestCount
    },
    getStatusType(status) {
      const map = {
        0: 'warning',
        1: 'success',
        2: 'danger',
      }
      return map[status] || 'info'
    },
    getStatusLabel(status) {
      const map = {
        0: '待审批',
        1: '已批准',
        2: '已拒绝',
      }
      return map[status] || '-'
    },
    async handleApprove(row) {
      try {
        await this.$confirm('确认同意该申请？同意后将自动扣减库存。', '提示', { type: 'warning' })
        const userRes = await getUserInfo()
        const userData = userRes.data && userRes.data.data
        const userId = userData ? (userData.userId || userData.id || userData.user_id) : null
        const userName = userData ? (userData.realName || userData.name || userData.nick_name) : ''

        const res = await approve(row.id, userId, userName)
        const body = res && res.data
        if (body && body.success && (body.code === 200 || body.code === 2000)) {
          this.$message.success('同意成功，库存已扣减')
          this.onLoad(this.page, this.query)
        } else {
          this.$message.error((body && body.msg) || '操作失败')
        }
      } catch (e) {
        if (e === 'cancel') {
          return
        }
        // 与接口失败体 { code, msg, success } 一致时，由 axios 拦截器已用 msg 提示，避免再弹「操作失败」
        if (!e || !e.message) {
          this.$message.error('操作失败')
        }
      }
    },
    handleReject(row) {
      this.currentRow = row
      this.rejectRemark = ''
      this.rejectVisible = true
    },
    async confirmReject() {
      if (!this.rejectRemark) {
        this.$message.warning('请输入拒绝原因')
        return
      }
      try {
        const userRes = await getUserInfo()
        const userData = userRes.data && userRes.data.data
        const userId = userData ? (userData.userId || userData.id || userData.user_id) : null
        const userName = userData ? (userData.realName || userData.name || userData.nick_name) : ''

        const res = await reject(this.currentRow.id, userId, userName, this.rejectRemark)
        const body = res && res.data
        if (body && body.success && (body.code === 200 || body.code === 2000)) {
          this.$message.success('已拒绝申请')
          this.rejectVisible = false
          this.onLoad(this.page, this.query)
        } else {
          this.$message.error((body && body.msg) || '操作失败')
        }
      } catch (error) {
        if (!error || !error.message) {
          this.$message.error('操作失败')
        }
      }
    },
    viewDetail(row) {
      this.$alert(
        `<p><strong>申请单号:</strong> ${row.requestNo}</p>
         <p><strong>备件名称:</strong> ${row.partName}</p>
         <p><strong>申请数量:</strong> ${row.requestCount}</p>
         <p><strong>当前库存:</strong> ${row.currentStock}</p>
         <p><strong>申请人:</strong> ${row.applicantName}</p>
         <p><strong>申请时间:</strong> ${row.requestTime}</p>
         <p><strong>用途:</strong> ${row.purpose || '-'}</p>
         <p><strong>审批人:</strong> ${row.approverName || '-'}</p>
         <p><strong>审批时间:</strong> ${row.approveTime || '-'}</p>
         <p><strong>审批备注:</strong> ${row.approveRemark || '-'}</p>`,
        '申请详情',
        { dangerouslyUseHTMLString: true }
      )
    },
  },
}
</script>

<style scoped lang="scss">
.stock-warning {
  color: #f56c6c;
  font-weight: 500;
}

.warning-text {
  font-size: 12px;
}
</style>
